/**
 * VIN Inline Form Component
 * Submits VIN via AJAX for inline form (add_vin_fitment module).
 * @author Waldo Panozo
 * @dependencies: jquery
 */
'use strict';

/**
 * submitVinInline
 * Submits VIN via AJAX. Validates 17-char VIN, POST to /ajax/collect-vin, shows error/success in containers.
 *
 * @param jQuery $vin_input Input field element
 * @param jQuery $submit_btn Submit button element
 * @param jQuery $error_container Error container element
 * @param jQuery $success_container Success container element
 * @param function onSuccess Callback on success (e.g. reload)
 * @return null
 */
function submitVinInline($vin_input, $submit_btn, $error_container, $success_container, onSuccess) {
	$error_container.hide().empty();
	$success_container.hide();

	const vin = $vin_input.val();
	const isValidLength = (typeof vin === 'string' && vin.length === 17);

	if (!vin || !isValidLength) {
		const errorMessage = globalThis.javascriptContent?.vin_modal_error_invalid_length || 'Please enter a valid 17-character VIN.';
		$error_container.empty().append(rp$('<p>').text(errorMessage)).show();
		return;
	}

	const submittingText = globalThis.javascriptContent?.vin_modal_submitting || 'Adding VIN';
	$submit_btn.prop('disabled', true).empty().append(rp$('<i>').addClass('fa fa-spinner fa-spin')).append(document.createTextNode(' ' + submittingText));

	globalThis.rp_app.request({
		method: 'POST',
		url: '/ajax/collect-vin',
		dataType: 'json',
		data: { vin: vin },
		success: function(response) {
			// Keep button in "Adding VIN" + spinner until page reloads
			if (typeof onSuccess === 'function') {
				onSuccess(response);
			}
		},
		statusCode: {
			400: function(jqxhr) {
				const submitText = globalThis.javascriptContent?.vin_modal_submit || 'Submit';
				$submit_btn.prop('disabled', false).text(submitText);
				var error_details;
				if ('responseText' in jqxhr && jqxhr.responseText) {
					try {
						error_details = JSON.parse(jqxhr.responseText);
					} catch (e) {
						error_details = { errors: [globalThis.javascriptContent?.vin_modal_error_invalid || 'VIN is invalid! Please check and try again.'] };
					}
				} else {
					error_details = { errors: [globalThis.javascriptContent?.vin_modal_error_invalid || 'VIN is invalid! Please check and try again.'] };
				}
				if (error_details && error_details.errors) {
					$error_container.empty();
					for (var i = 0, j = error_details.errors.length; i < j; i++) {
						$error_container.append(rp$('<p>').text(error_details.errors[i]));
					}
					$error_container.show();
				}
			}
		},
		error: function(jqxhr) {
			if (typeof this.statusCode[jqxhr.status] === 'function') {
				return;
			}
			const submitText = globalThis.javascriptContent?.vin_modal_submit || 'Submit';
			$submit_btn.prop('disabled', false).text(submitText);
			$error_container.empty().append(rp$('<p>').text(globalThis.javascriptContent?.vin_modal_error_general || 'An error occurred. Please try again later.')).show();
		}
	});
}

module.exports = {
	submitVinInline: submitVinInline
};
